// Home.js
import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';


import { API_BASE_URL, handleFile, renderModal, closeModal, fetchJsonFromUrl } from './Common';

import { ReactComponent as UploadIcon } from '../icons/upload.svg';
import { ReactComponent as MugIcon } from '../icons/mug.svg';
import { ReactComponent as FilecheckIcon } from '../icons/filecheck.svg';

import './Home.css';

function CreateProject() {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesSelected, setFilesSelected] = useState(false);
  const [healthData, setHealthData] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [url, setURL] = useState('');
  const [isCreating, setIsCreating] = useState(false); // State variable to track duplication process
  const [selectedOption, setSelectedOption] = useState('url'); // State variable to track selected option

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);

  const [saveAsStatic, setSaveAsStatic] = useState(true);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      let allFilesData = [];
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const result = event.target.result;
          handleFile(file, result, allFilesData, acceptedFiles.length, setFilesSelected, setHealthData); setUploadedFiles(prevFiles => [...prevFiles, file]);
        };
        reader.readAsBinaryString(file);
      });
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ['.xlsx', '.ods', '.csv', '.json'],
    multiple: true,
  });

  const handleCreateNewProject = async (projectName) => {
  try {
    setIsCreating(true); // Set the flag to indicate the creation process started
    const token = localStorage.getItem('token');

    let dataToUpload = [];

    // Handle URL option
    if (selectedOption === 'url') {
      if (saveAsStatic) {
        // Fetch data immediately for static data saving
        const urlData = await fetchJsonFromUrl(url);
        if (urlData) {
          dataToUpload = urlData;
        } else {
          console.error('Failed to fetch data from URL');
          setIsCreating(false);
          return;
        }
      } else {
        // Save the URL for real-time data fetching
        dataToUpload = { type: 'real-time', url: url };
      }
    } else if (selectedOption === 'upload') {
      // Handle file upload option
      dataToUpload = healthData;
    } else if (selectedOption === 'empty') {
  dataToUpload = [
    {
      sheetName: "Tabela",
      data: [
        ["Coluna 1", "Coluna 2", "Coluna 3"], // Column headers
        ["", "", ""],                      // Row 1 (empty)
        ["", "", ""],                      // Row 2 (empty)
        ["", "", ""]                       // Row 3 (empty)
      ]
    }
  ];
}

    // Make a POST request to the backend with healthData or URL information
    await axios.post(
      `${API_BASE_URL}/create-project`,
      {
        healthData: dataToUpload,
        databaseName: projectName,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Fetch the updated list of projects
    const response = await axios.get(`${API_BASE_URL}/projects`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

      //setProjects(response.data.projects);
      setIsCreating(false);

 setUploadedFiles([]);
 setFilesSelected(false);
 setHealthData([]);
 setProjectName('');
 setURL('');


      setModalMessage("Projeto criado!");
      setModalMessageColor('#41BBC9');
      setModalIconId(1);
      setIsModalOpen(true);

    } catch (error) {
      console.error('Error creating new project:', error);
      setIsCreating(false);

 setUploadedFiles([]);
 setFilesSelected(false);
 setHealthData([]);
 setProjectName('');
 setURL('');

      setModalMessage("Projeto com erros...");
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
    }
  };

  return (
    <div className="home-container">
      <h2>Criar Projeto</h2>
      <p>Upload de ficheiros para criar projeto</p>

      {/* Loading animation*/}
      {isCreating && (
        <div className="loading-overlay">
        <MugIcon/>
          <div className="loading-message">A carregar os dados...</div>
          <div className="loading-spinner"></div>
        </div>

      )}

      <header>
        <div className="create-project">
          <label className="project-name-label">Nome do Projeto</label>
          <input
            type="text"
            placeholder="Inserir nome do projeto"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />

<p className="project-name-label">URL</p>

{(selectedOption === 'upload' || selectedOption === 'empty') && (
          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="url"
              checked={selectedOption === 'url'}
              onChange={() => setSelectedOption('url')}
            />
          </div>
)}

{selectedOption === 'url' && (
            <>
              <input
                type="text"
                placeholder="Inserir URL"
                value={url}
                onChange={(e) => setURL(e.target.value)}
              />
              <div className="url-options">
                <label className="radio-spacing">
                  <input
                    type="radio"
                    name="saveOption"
                    value="static"
                    checked={saveAsStatic}
                    onChange={() => setSaveAsStatic(true)}
                  />
                  Dados Estáticos
                </label>
                <label className="radio-spacing">
                  <input
                    type="radio"
                    name="saveOption"
                    value="real-time"
                    checked={!saveAsStatic}
                    onChange={() => setSaveAsStatic(false)}
                  />
                  Tempo Real
                </label>
              </div>
            </>
          )}

<p className="project-name-label">Upload de ficheiros</p>


{(selectedOption === 'url' || selectedOption === 'empty') && (
          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="upload"
              checked={selectedOption === 'upload'}
              onChange={() => setSelectedOption('upload')}
            />
          </div>
)}

{selectedOption === 'upload' && (
            <div className="dropzone-container">
              <div {...getRootProps({ className: 'dropzone' })}>
              {uploadedFiles.length === 0 && (
      <>
              <UploadIcon/>
                <input {...getInputProps()} />
                {
              isDragActive ?
                <p>
                <span className="yellow-text">Solte aqui...</span>
                </p> :
                (<>
                <p>
                <span className="yellow-text">Clique para upload</span>
                <span className="blue-text"> ou arraste e
                <span className="green-text"> solte</span>
                </span>
                </p>
                <p><span className="red-text">(ODS, XLSX, CSV, XML, JSON)</span></p>
                </>
                )
                }
</>
    )}
        {uploadedFiles.length > 0 && (
      <>
      <FilecheckIcon/>
        <p className="file-list-header">Ficheiro inserido!</p>
        <ul>
          {uploadedFiles.map((file, index) => (
            <li key={index} className="file-item">{file.name}</li>
          ))}
        </ul>
      </>
    )}
              </div>
            </div>
          )}

<p className="project-name-label">Projeto Vazio</p>

          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="empty"
              checked={selectedOption === 'empty'}
              onChange={() => setSelectedOption('empty')}
            />
          </div>


          {((filesSelected && selectedOption === 'upload') || (url && selectedOption === 'url') || (selectedOption === 'empty')) && (
            <div className="create-project">
              <button
              className="button"
              style={{
    position: 'fixed',
    bottom: '37px',
    right: '37px'
  }}
              onClick={() => handleCreateNewProject(projectName)}>Criar projeto</button>
            </div>
          )}
        </div>
      </header>

{/*Delete ou Export sucess*/}
{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

    </div>
  );
}

export default CreateProject;
